import $ from 'jquery'
import 'slick-carousel'

var badges_carousel = $('.badges-carousel')

$(badges_carousel).slick({
	autoplay: true,
	autoplaySpeed: 4000,
	centerMode: true,
	centerPadding: '60px',
	infinite: true,
	slidesToShow: 9,
	arrows: false,
	dots: false,
	draggable: false,
	swipe: false,
	pauseOnFocus: false,
	pauseOnHover: false,
	pauseOnDotsHover: false,
	responsive: [
		{
			breakpoint: 1260,
			settings: {
				slidesToShow: 7,
			},
		},
		{
			breakpoint: 900,
			settings: {
				slidesToShow: 5,
			},
		},
		{
			breakpoint: 500,
			settings: {
				slidesToShow: 3,
			},
		},
	],
})

$(badges_carousel).on(
	'beforeChange',
	function (event, slick, currentSlide, nextSlide) {
		var colored_image = $(
			`.badges-carousel [data-slick-index="${nextSlide}"]`
		).find('img.colored-image')

		$(badges_carousel).find('img').removeClass('active')
		$(colored_image).addClass('active')
	}
)

$(badges_carousel).show()
